import React, { useCallback, useEffect, useRef, useState } from "react";
import {
  // Table,
  Button,
  Modal,
  Nav,
  Dropdown,
  Form,
  // Row,
  // Col,
  Spinner,
  // Alert,
  // Toast,
  // ListGroup
} from "react-bootstrap";
import useReactRouter from "use-react-router";
import ReactHTMLTableToExcel from "react-html-table-to-excel";
import * as _ from "lodash";

// import moment from "moment";
import {
  convertOrderStatus,
  // convertOrderType,
} from "../../helpers/orderStatus";
import "react-spring-bottom-sheet/dist/style.css";
import { useToasts } from "react-toast-notifications";
import { GET_ORDERS, GET_ORDERGROUPS_V2 } from "../../graphql/order/query";
import { useLazyQuery, useMutation, useQuery } from "@apollo/client";
import {
  CTREATE_MANY_PREORDER_DELIVERY,
  DELETE_ORDER,
  DELETE_ORDER_GROUP,
  UPDATE_MANY_ORDER,
  UPDATE_MANY_ORDERGROUPS,
  UPDATE_ORDER,
  UPDATE_ORDERGROUP,
} from "../../graphql/order/mutation";
import { UPDATE_STOCK, CANCELLED_ORDER_GROUPS } from "../../graphql/stock/mutation";
// import { GET_STOCK } from "../../graphql/stock/query";
import { GET_LIVE_STOCKS } from "../../graphql/liveStock/query";
import "./styleOrderList.css";
import {
  convertCurrentDate, imageRender, numberFormat, calculateRoundedValue, convertPriceWithCommission,
  // thousandSeperate 
} from "../../helpers";
import { exportToExcelNewFormat } from "../../helpers/excelExportUtils";
import {
  // CANCELLED,
  COLOR_APP,
  COLOR_WHITE,
  COMPLETED,
  // CREATED,
  HAL_KEY,
  LINEAR_GRADIENT_BG,
  MIXAY_KEY,
  // ORDERINSALEPAGE,
  // READYTOSHIP,
  // S3_URL,
  // SHIPPING,
  SHIPPING_COMPLETED,
} from "../../constants";
import useWindowDimensions from "../../helpers/useWindowDimensions";
import PaginationHelper from "../../helpers/PaginationHelper";
import OrderGroupDownload from "./OrderGroupDownload";
import ReactToPrint from "react-to-print";
import OrderBillWithNameOnePage from "./orderBillWithNameOnePage";
import CreateOrderTable from "./CreateOrderTable";
import Swal from "sweetalert2";
import BtnClaimBalanceReport from "../../components/orderComponent/button/btn.orderGroupClaimBalance";
import DropdownClaimBalance from "../../components/orderComponent/dropdown/dropdown.OrderGroup";
import { FaDownload, FaLuggageCart } from "react-icons/fa";
import { MdAdd, MdClose, MdDateRange, MdEditNote, MdPrint, MdSearch } from "react-icons/md";
import CurrentDateModal from "../../components/currentComponent/CurrentDateModal";
import { FiAward } from "react-icons/fi";
import BtnJointCfOrderGroup from "../../components/orderComponent/button/btn.jointCfOrderGroup";
import { SHOP } from "../../graphql/shop/queryShop";
import SelectDeliveryDailog from "./orderDelivery/SelectDeliveryDailog";
import BillOrder100x150 from "../../components/bill.orderGroups/BillOrder100x150";
import { GET_EXCHANGRATE } from "../../graphql/exchangeRate/Query";
import ModalConfirmComponent from "../../components/ModalConfirmComponent";
import { errorSwal, successSwal } from "../../helpers/sweetalert";
import { HiDotsVertical } from "react-icons/hi";
import { GET_SETTING_BY_SHOP } from "../../graphql/setting/query";
import LoadingSpinner from "../../components/LoadingSpinner";
import OrderDetails from "./orderDetail/OrderDetail";
import BtnJointAllOrderGroup from "../../components/orderComponent/button/btn.jointAllOrderGroup";
import BtnCancelJointOrderGroup from "../../components/orderComponent/button/btn.cancelJointOrderGroup";
import BillOrder100x150_V2 from "../../components/bill.orderGroups/BillOrder100x150_V2";
import RefreshClaimBalanceFailed from "../../components/orderComponent/dropdown/refreshClaimBalanceFailed";
import ConfirmBalance from "../../components/orderComponent/dropdown/confirmBalance";
import OrderBillWithNameOnePageV2 from "./orderBillWithNameOnePageV2";

const statusDataStrings = [
  "CREATED",
  "COMPLETED",
  "CANCELLED",
  "IMAGE_NOT_YET_PAID",
  "PAYMENT_STILL_INCOMPLETE",
  "USERCONFIRM",
  "PRINT_ORDER",
  "WAITINGCONFIRM",
  "SHIPPING", "READYTOSHIP", "PAYMENT_PROCESSING", "SHIPPING_COMPLETED",
];

// Constants for delivery types
const DELIVERY_NAMES = {
  [HAL_KEY]: "ຮຸ່ງອາລຸ່ນ",
  [MIXAY_KEY]: "ມີໄຊ",
  
};

const MAX_ORDER_DELIVERY_LIMIT = 10;

function Orders() {
  const { width } = useWindowDimensions();
  const { addToast } = useToasts();
  const { history } = useReactRouter();


  const [pageNumber, setPageNumber] = useState(1);
  const [pageCountNumber, setPageCountNumber] = useState(1);
  const [orderList, setOrderList] = useState([]);
  const [orderGroupList, setOrderGroupList] = useState([]);
  const [orderGroupTotal, setOrderGroupTotal] = useState(0);
  const [selectedOrder, setSelectedOrder] = useState();
  const [selectedOrderGroup, setSelectedOrderGroup] = useState();
  const [selectedIds, setSelectedIds] = useState([]);
  const [selectedOrderIds, setSelectedOrderIds] = useState([]);
  const [selectedData, setSelectedData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [isSelectAll, setIsSelectAll] = useState(false);
  const [currentStartDate, setCurrentStartDate] = useState();
  const [currentEndDate, setCurrentEndDate] = useState();
  const [isDeliveries, setIsDeliveries] = useState([]);
  const [isDeliveriesLA, setIsDeliveriesLA] = useState([]);
  const [selectLimit, setSelectLimit] = useState(50)

  const [listpage, setlistpage] = useState("CREATED");
  const [isClickAllTransfer, setIsClickAllTransfer] = useState();
  const [searchText, setSearchText] = useState("");
  const [orderGroupType, setOrderGroupType] = useState("ALL");
  const [orderGroupDownload, setOrderGroupDownload] = useState([]);
  const [selectedOrderGroupStatus, setSelectedOrderGroupStatus] = useState();
  const [showImageModal, setshowImageModal] = useState(false);
  const [showDetailModal, setshowDetailModal] = useState(false);
  const [selectedImage, setSelectedImage] = useState("");
  const [paySlips, setPaySlips] = useState([]);
  const [copied, setCopied] = useState("");
  const [isPaymented, setIsPaymented] = useState("ALL");
  const [cdFillter, setCdFillter] = useState({
    createdAt_gte: "",
    createdAt_lt: "",
  });
  const [isCurrentModals, setIsCurrentModals] = useState(false);
  // const [activeButton, setActiveButton] = useState("thisMonth");
  const [activeButton, setActiveButton] = useState("thisWeek");
  const [totalPaymentAuto, setTotalPaymentAuto] = useState(0)
  const [isFetch, setIsFetch] = useState(false)
  const [isClaimBalance, setIsClaimBalance] = useState()

  const [showOrder, setShowOrder] = useState(false);
  const [showOrderAll, setShowOrderAll] = useState(false);
  const [showChangeOrderStatus, setShowChangeOrderStatus] = useState(false);
  const shopId = localStorage.getItem("SHOP")
  const [shopDataDetail, setShopDataDtail] = useState()
  const [openSelectLogictics, setOpenSelectLogictics] = useState(false)
  const [orderGroupIdSelect, setOrderGroupIdSelect] = useState()
  const [isPrintBill, setIsPrintBill] = useState(false)
  const [rateData, setRateData] = useState()
  const [isShowFilterBox, setIsShowFilterBox] = useState(false)
  const [valueFilterBox, setValueFilterBox] = useState()
  const parentDivRef = useRef(null);

  //MOBILE

  // const [getOrderData, { data: orderData }] = useLazyQuery(GET_ORDERS, {
  //   fetchPolicy: "cache-and-network",
  // });
  const [getLiveStockRefilData, { data: liveStockRefilData }] = useLazyQuery(
    GET_LIVE_STOCKS,
    { fetchPolicy: "cache-and-network" }
  );
  const [
    getOrderGroupsData,
    { data: orderGroupData, loading: orderGroupLoading },
  ] = useLazyQuery(GET_ORDERGROUPS_V2, { fetchPolicy: "cache-and-network" });

  // setting by shop
  const { data: settingData } = useQuery(GET_SETTING_BY_SHOP, {
    fetchPolicy: "network-only",
    variables: {
      where: {
        shop: shopId,
      },
    },
  });


  // appollo client hooks
  const [loadShopData, { data: getShopData, loading: loadingShop }] = useLazyQuery(SHOP, { fetchPolicy: "network-only" });
  const [getExchangeRate, { data: loadExchangeRate, loading: loadingExrate }] = useLazyQuery(GET_EXCHANGRATE, { fetchPolicy: "cache-and-network" });

  const [updateOrder] = useMutation(UPDATE_ORDER);
  const [updateOrderGroup, { loading: updateOrderGroupLoading }] = useMutation(UPDATE_ORDERGROUP);
  const [updateManyOrders] = useMutation(UPDATE_MANY_ORDER);
  const [deleteOrder] = useMutation(DELETE_ORDER);
  const [deleteOrderGroup] = useMutation(DELETE_ORDER_GROUP);
  const [updateStock] = useMutation(UPDATE_STOCK);
  const [cancelOrderGroups, { loading: cancelOrderGroupLoading }] = useMutation(CANCELLED_ORDER_GROUPS);
  const [updateManyOrderGroups, { loading: updateorderManyLoading }] = useMutation(UPDATE_MANY_ORDERGROUPS);
  const [createManyPreorderOfDelivery, { loading: createManyPreorderLoading }] = useMutation(CTREATE_MANY_PREORDER_DELIVERY);

  // Paggination helper
  const { _limit, _skip, Pagination_helper } = PaginationHelper();

  // handle click outside to close box filter
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        parentDivRef.current &&
        !parentDivRef.current.contains(event.target)
      ) {
        setIsShowFilterBox(false);
        setValueFilterBox('')
      }
    };

    // Attach the event listener to the document body
    document.body.addEventListener("click", handleClickOutside);

    // Clean up the event listener when the component unmounts
    return () => {
      document.body.removeEventListener("click", handleClickOutside);
    };
  }, []);

  const dropdownRef = useRef(null);

useEffect(() => {
  function handleClickOutside(event) {
    if (dropdownRef.current && !dropdownRef.current.contains(event.target) && showDropdownAction) {
      setShowDropdownAction(false);
    }
  }
  
  // Add event listener when the dropdown is shown
  if (showDropdownAction) {
    document.addEventListener('mousedown', handleClickOutside);
  }
  
  // Clean up the event listener
  return () => {
    document.removeEventListener('mousedown', handleClickOutside);
  };
}, []);

  let componentRef = useRef();

  const notifyCreateOrderSuccess = () =>
    Swal.fire({
      title: "ສ້າງອໍເດີ້ສຳເລັດ",
      icon: "success",
      timer: 2500,
      showConfirmButton: false,
    });

  const notifyStatusSuccess = () =>
    Swal.fire({
      title: "ປ່ຽນສະຖານະການໂອນສຳເລັດ",
      icon: "success",
      timer: 2500,
      showConfirmButton: false,
    });

  const handleOrderStatusChange = async () => {
    triggerShowOrder();
  };

  const triggerHideShowOrder = () => setShowOrder(false);
  const triggerShowOrder = () => setShowOrder(true);
  const handleUpdateOrderAll = () => setShowOrderAll(true);
  const handleHideUpdateOrderAll = () => setShowOrderAll(false);
  const [searchKeyWord, setSearchKeyWord] = useState("");
  const [logicticsName, setLogicticsName] = useState()
  const [showCreatePreorder, setShowCreatePreorder] = useState(false)
  const [orderDeliveryIds, setOrderDeliveryIds] = useState([])
  const [showDropdownAction, setShowDropdownAction] = useState(false)
  const parentDropdownRef = useRef(null);


  const triggerHideShowChangeOrderStatus = () =>
    setShowChangeOrderStatus(false);

  const handleOrderStatusChange2 = async () => {
    triggerHideShowChangeOrderStatus();
    setIsClickAllTransfer(true);

    notifyStatusSuccess();
  };

  // useEffect 
  useEffect(() => {
    if (shopId) {
      loadShopData({
        variables: {
          where: {
            id: shopId,
          },
        },
      });
      getExchangeRate({
        variables: {
          where: {
            shop: shopId,
          },
        },
      });
    }
  }, [shopId]);


  useEffect(() => {
    if (getShopData) {
      setShopDataDtail(getShopData?.shop);
    }
  }, [getShopData]);

  useEffect(() => {
    if (loadExchangeRate?.exchangeRate) {
      setRateData(loadExchangeRate?.exchangeRate)
    }
  }, [loadExchangeRate?.exchangeRate])


  useEffect(() => {
    setOrderGroupDownload([]);
    setIsSelectAll(false);
    setSelectedIds([]);
    setSelectedOrderIds([]);
    // _filter();
    // getOrderGroup(listpage);
    if (!_.isEmpty(listpage)) setIsClaimBalance('');

  }, [listpage]);

  useEffect(() => {
    _filter();
    // handleFilterOrders();
  }, [
    searchText,
    currentStartDate,
    currentEndDate,
    orderGroupType,
    _skip,
    listpage,
    pageNumber,
    searchKeyWord,
    isPaymented,
    cdFillter,
    isClaimBalance,
    isFetch,
    logicticsName
  ]);

  const _filter = async (_values) => {
    try {
      let SHOP_ID = await localStorage.getItem("SHOP");
      // setOrderGroupList([]);
      setIsLoading(true);

      let _where = {
        shop: SHOP_ID,
        isDeleted: false,
        // shipmentPayType: "CDC",
        // delivery: "HAL",
      };

      // if (listpage !== "") {
      if (!_.isEmpty(listpage)) {
        // if(listpage)
        _where = {
          ..._where,
          status: listpage === COMPLETED ? [COMPLETED, "SHIPPINGCOMPLETED", SHIPPING_COMPLETED] : [listpage],
        };
      } else {
        // sale page select all status  but don't get status 
        if (orderGroupType === "SALE_PAGE") {
          _where = {
            ..._where,
            status: [COMPLETED, "SHIPPINGCOMPLETED", SHIPPING_COMPLETED, "CREATED", "READY_TO_SHIPPING", "SHIPPING", "CANCELLED",
              "IMAGE_NOT_YET_PAID", "PAYMENT_STILL_INCOMPLETE",
              "USERCONFIRM", "PRINT_ORDER"
            ]
          };
        }
      }

      if (!_.isEmpty(logicticsName)) {
        _where = { ..._where, delivery: logicticsName }
      }

      if (!_.isEmpty(isClaimBalance) && _.isEmpty(listpage)) {
        if (isClaimBalance === "true") {
          _where = { ..._where, isClaimBalance: true }
        }
        if (isClaimBalance === "false") {
          _where = { ..._where, isClaimBalance: false }
        }
      }

      if (isPaymented === '1' || isPaymented === '0') {
        _where = {
          ..._where,
          isPaymented: isPaymented === '1' ? true : false,
        };
      } else if (isPaymented === "PAYMENT_SUPPORT" || isPaymented === "PAYMENT_MANNULE") {
        _where = {
          ..._where,
          isPaymentSupport: isPaymented
        }
      }


      // TODO: check if search text is not empty
      // code: searchText
      // if (!_.isEmpty(searchText)) {
      //   _where = {
      //     ..._where,
      //     OR: [{ cfName: searchText }, { code: searchText }],
      //   };
      // }

      if (!_.isEmpty(searchKeyWord)) {
        _where = { ..._where, searchKeyWord }
      }



      //check if status is selected
      if (orderGroupType != "ALL") {
        _where = {
          ..._where,
          type: orderGroupType,
        };
      }


      const splitDateTime = (dateString) => {
        const date = new Date(dateString);
        const datePart = date.toISOString().split('T')[0];
        const timePart = date.toISOString().split('T')[1].split('.')[0];
        return datePart;
      };

      //check if filter date is set
      if (!_.isEmpty(cdFillter)) {
        let startDateComponents = splitDateTime(cdFillter?.createdAt_gte);
        let endDateComponents = splitDateTime(cdFillter?.createdAt_lt);
        _where = {
          ..._where,
          createdAt_gte: startDateComponents,
          createdAt_lt: endDateComponents,
          // createdAt_gte: new Date(
          //   moment(moment(cdFillter?.createdAt_gte).format("DD-MM-YYYY")).toISOString()
          // ),
          // createdAt_lt: new Date(
          //   moment(moment(cdFillter?.createdAt_lt).add(1, "days")).format("DD-MM-YYYY")
          // ).toISOString(),
        };
      }


      // console.log({ _where })
      const limitValue = !_.isEmpty(_values) ? parseInt(_values, 10) : _limit;

      // TODO: Get all order groups
      await getOrderGroupsData({
        variables: {
          where: _where,
          skip: (_skip - 1) * _limit,
          limit: limitValue,
          orderBy: "createdAt_DESC",
        },
      });
      setPageNumber(1);
      setIsLoading(false);
      // console.log({ t })
    } catch (error) {
      setIsLoading(false);
      console.log("Error: ", error);
    }
  };


  const handleCreateManyPreOrderDelivery = async () => {
    const _shopId = localStorage.getItem("SHOP")
    try {
      if (createManyPreorderLoading) return;
      await createManyPreorderOfDelivery({
        variables: {
          // where: {
          //   shop: _shopId
          // },
          data: {
            orderDeliveryIds: orderDeliveryIds,
            deliveries: isDeliveries
          }
        }
      }).then((response) => {
        if (response?.data?.createManyPreOrderDelivery?.message === "CREATE_PRE_ORDER_COMPLETED") {
          successSwal("ສ້າງອໍເດີ້ຂົນສົ່ງສຳເລັດແລ້ວ")
          setOrderGroupDownload([])
          setOrderDeliveryIds([])
          setShowCreatePreorder(false)
          _filter()
        } else {
          errorSwal("ສ້າງອໍເດີ້ຂົນສົ່ງບໍ່ສຳເລັດ")
          setShowCreatePreorder(false)
        }
      })

    } catch (error) {
      console.log("error:", error)
      errorSwal("ສ້າງອໍເດີ້ລົ້ມແຫຼວ!")
      setShowCreatePreorder(false)
    }
  }


  useEffect(() => {
    if (orderGroupData?.orderGroupsV2) {
      setLoading(false);
      setOrderGroupList(orderGroupData?.orderGroupsV2?.data);
      setOrderGroupTotal(orderGroupData?.orderGroupsV2?.total);
      setPageCountNumber(
        parseInt(orderGroupData?.orderGroupsV2?.total / _limit) + 1
      );
      // sum total in ordergroups
      const sumTotalPrice = orderGroupData?.orderGroupsV2?.data.filter(orderGroup => orderGroup.isClaimBalance).reduce((acc, orderGroup) => acc + orderGroup.totalPrice, 0);
      if (sumTotalPrice) {
        setTotalPaymentAuto(sumTotalPrice)
      }
    }
  }, [orderGroupData]);

  useEffect(() => {
    downloadOrderToExcel();
  }, [selectedIds]);

  // useEffect(() => {
  //   onNextOrBackPage();
  // }, [pageNumber])

  useEffect(() => {
    if (liveStockRefilData) {
      // setLoading(false)
      updateStockRefil02();
    }
  }, [liveStockRefilData]);

  // useEffect(() => {
  //   console.log({ orderGroupDownload })
  // }, [orderGroupDownload])

  // useEffect(() => {
  //   _filter()
  // }, [currentStartDate, currentEndDate])

  // const checkSelectedOrder = (order) => {
  //   if (!selectedOrder) return false;
  //   if (selectedOrder === order) return true;
  //   else return false;
  // };

  const downloadOrderToExcel = async () => {
    let _dataForExport = [];
    for (var i = 0; i < selectedIds.length; i++) {
      await _dataForExport.push(orderList[selectedIds[i]]);
    }
    let _data = [];
    for (var i = 0; i < _dataForExport.length; i++) {
      await _data.push({
        id: _dataForExport[i]?.id,
        productName: _dataForExport[i]?.productName || "",
        option: _dataForExport[i]?.option || "",
        price: _dataForExport[i]?.price || "",
        cfName: _dataForExport[i]?.cfName || "",
        phone: _dataForExport[i]?.phone || "",
        status: _dataForExport[i]?.status || "",
        payment: _dataForExport[i]?.payment || "",
        message: _dataForExport[i]?.message || "",
        live: _dataForExport[i]?.live || "",
        createdAt: _dataForExport[i]?.createdAt || "",
      });
    }

    setSelectedData(_data);
  };

  const getSeletedOrder = async (index, order) => {
    const checkId = await selectedIds?.filter((item) => index == item);
    // console.log({ checkId })
    if (checkId.length == 0) {
      let _selectedIds = [...selectedIds];
      _selectedIds.push(index);
      setSelectedIds(_selectedIds);

      setOrderGroupDownload((currentOrderGroups) => [
        ...currentOrderGroups,
        order,
      ]);
    } else {
      const checkId = await selectedIds?.filter((item) => index != item);
      setSelectedIds(checkId);

      setOrderGroupDownload((currentOrderGroups) =>
        currentOrderGroups.filter((orderGroup) => orderGroup?.id !== order?.id)
      );
    }

    // console.log("selectedIds====>", selectedIds)
  };

  const onSeletedAllOrder = async () => {
    if (isSelectAll) {
      await setSelectedIds([]);
      setSelectedOrderIds([]);
    } else {
      let _selectedIds = orderGroupList.map(({ id }) => id);
      const _selectedOrderIds = orderGroupList.flatMap((orderGroup) => {
        const orderIds = orderGroup?.orders?.map((order) => order?.id);
        return orderIds;
      });
      // for (var i = 0; i < orderList.length; i++) {
      //   await _selectedIds.push(i);
      // }
      // console.log({ _selectedOrderIds });
      setSelectedIds(_selectedIds);
      setSelectedOrderIds(_selectedOrderIds);
    }
    setIsSelectAll(!isSelectAll);
  };

  // on cancel select item or order id
  const onCancelSelectItem = () => {
    setOrderGroupDownload([]);
    setIsSelectAll(false);
    setSelectedIds([]);
    setSelectedOrderIds([]);
    setOpenSelectLogictics(false)
    setOrderGroupIdSelect()
  }


  const updateStockRefil02 = async () => {
    await updateStock({
      variables: {
        where: {
          id: liveStockRefilData.liveStocks?.data[0]?.stock?.id,
        },
        data: {
          amount: liveStockRefilData.liveStocks?.data[0]?.stock?.amount + 1,
        },
      },
    });
  };

  // CANCELLED ORDER GROUP
  const cancelOrderGroupsWeb = async (id_in) => {
    try {
      if (cancelOrderGroupLoading) return;
      await cancelOrderGroups({ variables: { where: { id_in } } });
      handleAlert("ຍົກເລີກອໍເດີ້ ສຳເລັດ!", "success");
    } catch (error) {
      handleAlert("ຍົກເລີກອໍເດີ້ ບໍ່ສຳເລັດ!", "error");
      console.log("FAILED: cancel order groups");
    }
  };

  const handleAlert = (message, appearance) => addToast(message, { appearance, autoDismiss: true });

  // New Excel export function with custom format - now using extracted utility
  const handleExportToExcelNewFormat = () => {
    exportToExcelNewFormat(orderGroupDownload, rateData, addToast);
  };

  const _onUpdateOrderGroupStatus = async () => {
    if (updateOrderGroupLoading) return;
    let _data = {
      status: selectedOrderGroupStatus,
    }
    if (selectedOrderGroupStatus === "CREATED" || selectedOrderGroupStatus === "IMAGE_NOT_YET_PAID" || selectedOrderGroupStatus === "PAYMENT_STILL_INCOMPLETE") {
      _data = {
        ..._data,
        isClaimBalance: false
      }
    } else if (selectedOrderGroupStatus === "CANCELLED") {
      const id_in = [selectedOrderGroup?.id];
      await cancelOrderGroupsWeb(id_in);
      return;
    }

    await updateOrderGroup({
      variables: {
        data: _data,
        where: {
          id: selectedOrderGroup?.id,
        },
      },
    });
    triggerHideShowOrder();
    notifyCreateOrderSuccess();
    _filter();
    // handleFilterOrders();
  };

  // update order group status all
  const _onUpdateOrderGroupStatusAll = async () => {
    if (updateorderManyLoading) return;
    let _data = {
      status: selectedOrderGroupStatus,
    }
    if (selectedOrderGroupStatus === "CREATED" || selectedOrderGroupStatus === "IMAGE_NOT_YET_PAID" || selectedOrderGroupStatus === "PAYMENT_STILL_INCOMPLETE") {
      _data = {
        ..._data,
        isClaimBalance: false
      }
    } else if (selectedOrderGroupStatus === "CANCELLED") {
      await cancelOrderGroupsWeb(selectedIds);
      return;
    }

    const updateOrderStatus = await updateManyOrderGroups({
      variables: {
        where: {
          id_in: selectedIds,
          orderIds: selectedOrderIds,
        },
        data: _data,
      },
    });
    if (updateOrderStatus) {
      addToast(`ອັບເດດສະຖານະສຳເລັດແລ້ວ!`, {
        appearance: "success",
        autoDismiss: true,
        timer: 3000,
      });
      setIsSelectAll(false);
      setSelectedOrderIds([]);
      setSelectedIds([]);
      handleHideUpdateOrderAll();
      _filter();
    }
  };

  const _gotoOrderGroupDetail = (orderId, order) => {
    history.push(`/orders-add`, { editMode: true, orderGroup: order });
  };


  const getCfMessage = (orders) => {
    return orders?.map(({ cfMessage }) => cfMessage)?.join(", ");
  };

  const handleCchangePaid = (e) => {
    let _paid = e.target.value;
    // if (_paid === "PAYMENT_SUPPORT") {
    //   setIsPaymentSupport(_paid)
    //   return;
    // }
    setIsPaymented(_paid)
  }




  const handleSelectLimit = (e) => {
    const _values = e?.target?.value; // Get the new limit value
    setSelectLimit(parseInt(_values))
    // Extract the current pathname
    let pathname = history.location.pathname;

    // Use regular expression to replace the limit value in the URL
    if (pathname.match(/\/limit\/\d+/)) {
      pathname = pathname.replace(/(\/limit\/)\d+/, `/limit/${_values}`);
    } else {
      // If no limit is present in the URL, append it
      pathname += `/limit/${_values}`;
    }

    // Reset page to 1 whenever limit changes
    if (pathname.match(/\/page\/\d+/)) {
      pathname = pathname.replace(/(\/page\/)\d+/, '/page/1');
    } else {
      // If no page is present in the URL, append it
      pathname += '/page/1';
    }

    // Use history.push() or history.replace() to update the URL
    history.replace(pathname);

    // Optionally, call the filter function to update the view
    _filter(_values);
  };

  // on create pre order to delivery
  const handleCreatePreOrder = (data) => {
    setOrderGroupIdSelect(data)
    setOpenSelectLogictics(true)
  }

  const onAfterPrintBill = () => {

    setShowDropdownAction(false)
    setOrderGroupDownload([])
    setIsSelectAll(false);
    setSelectedIds([]);
    setSelectedOrderIds([]);
  }

  const onSelectLogictics = (e) => {
    let _newValues = e?.target?.value;

    setLogicticsName(_newValues)
  }

  const handleLoopOrderDelivery = () => {
    // Get matched order IDs using optional chaining
    const matchedOrders = orderGroupDownload.filter(
      orderGroup => orderGroup?.orderDelivery?.match === true
    );

    const matchedOrderIds = matchedOrders.map(
      orderGroup => orderGroup?.orderDelivery?.id
    );

    // Validation checks
    if (_.isEmpty(matchedOrderIds)) {
      return errorSwal(
        "ອໍເດີ້ນີ້ ຂໍ້ມູນຂົນສົ່ງ ບໍ່ກົງກັນ ລະຫວ່າງຕົ້ນທາງ ກັບ ປາຍທາງ ",
        "warning"
      );
    }

    if (matchedOrderIds.length > MAX_ORDER_DELIVERY_LIMIT) {
      return errorSwal(
        `ການສ້າງອໍເດີ້ຂົນສົ່ງ ບໍ່ຄວນເລືອກເກີນ ${MAX_ORDER_DELIVERY_LIMIT} ລາຍການ!`,
        "error"
      );
    }

    // Get unique delivery types
    const deliveryTypes = matchedOrders
      .map(orderGroup => orderGroup?.orderDelivery?.delivery)
      .filter(Boolean);

    const uniqueDeliveriesLA = [...new Set(deliveryTypes)]
      .map(type => DELIVERY_NAMES[type])
      .filter(Boolean);

    const uniqueDeliveries = [...new Set(deliveryTypes)]
      .map(type => type)
      .filter(Boolean);

    // Update state
    setIsDeliveries(uniqueDeliveries);
    setIsDeliveriesLA(uniqueDeliveriesLA);
    setShowCreatePreorder(true);
    setOrderDeliveryIds(matchedOrderIds);
  };

  // handle shortcut for your button
  const handleKeyDown = useCallback((event) => {
    if ((event.metaKey && event.key === 'k') || (event.ctrlKey && event.key === 'k')) {
      event.preventDefault();
      setIsShowFilterBox(true);
    }
  }, []);

  useEffect(() => {
    window.addEventListener('keydown', handleKeyDown);
    return () => {
      window.removeEventListener('keydown', handleKeyDown);
    };
  }, [handleKeyDown]);

  // onchange to search data and set data to searchKeywork
  const onchangeFilterOrderDatas = (event) => {
    event.preventDefault();
    setSearchKeyWord(valueFilterBox)
  }


  return (
    <div style={{ paddingBottom: 40, position: 'relative' }}>

      <div>
        <OrderGroupDownload orderGroupDownload={orderGroupDownload} />
        <div>

          <div className="d-flex justify-content-between pt-2">
            <h4 style={{ padding: '10px 2px' }}>
              ອໍເດີ້ທັງໝົດ {numberFormat(orderGroupTotal ?? 0)} ບິນ
            </h4>
            <div style={{ padding: 10 }}>
              <Button style={{ background: COLOR_APP, border: 'none' }} onClick={() => history.push("/orders-add")}><MdAdd /> ສ້າງອໍເດີ້ເອງ</Button>
            </div>
            {/* <Alert variant="success" style={{ position: 'relative', cursor: 'pointer' }}>
              <div onClick={() => history.push("/invoice_orders/limit/50/page/1")} className="kream-button"><BsFillCreditCard2BackFill style={{ fontSize: 32 }} />ຖອນເງິນ</div>
              ຍອດເງິນ Payment Support<span style={{ fontSize: 20, fontWeight: 'bold' }}>{numberFormat(totalPaymentAuto)} ກີບ</span>

            </Alert> */}
          </div>

          <div className="Contain">

            <BtnClaimBalanceReport cdFillter={cdFillter} listpage={listpage} setlistpage={setlistpage} isClaimBalance={isClaimBalance} setIsClaimBalance={setIsClaimBalance} isFetch={isFetch} start={currentStartDate} end={currentEndDate} type={orderGroupType} total={orderGroupTotal} />

          </div>
          <div
            style={{
              background: "white",
              // margin: "0px 9px",
              padding: "1px",
            }}
          >
            <div style={{ display: "flex", flexDirection: "column" }}>
              <div className="card-actions-table">

                <div className="box-filter">
                  <label>ວັນທີ,ເດືອນ,ປີ</label>

                  <Button
                    variant="outline-secondary"
                    onClick={() => setIsCurrentModals(true)}
                    style={{ width: "100%", display: 'flex', gap: 5, justifyContent: 'space-between', alignItems: 'center' }}

                  >
                    <MdDateRange style={{ fontSize: 25 }} />
                    {cdFillter?.createdAt_gte === "" && cdFillter?.createdAt_lt === "" ? (
                      "mm/dd/yyyy"
                    ) : (
                      <>
                        {convertCurrentDate(cdFillter?.createdAt_gte) + "-" + convertCurrentDate(cdFillter?.createdAt_lt)}
                      </>
                    )}
                  </Button>
                </div>

                <div className="box-filter">
                  <label>ສະຖານະອໍເດີ້</label>
                  <Form.Select
                    onChange={(e) => setlistpage(e.target.value)}
                    className="form-control"
                    style={{
                      fontSize: "16px",
                      whiteSpace: "nowrap",
                    }}
                    value={listpage}
                    defaultValue={"CREATED"}
                    aria-label="Default select example"
                  >
                    <option selected value="">
                      --ທັງຫມົດ--
                    </option>
                    <option value="CREATED">ອໍເດີເຂົ້າ</option>
                    <option value="READY_TO_SHIPPING">ອໍເດີພ້ອມສົ່ງ</option>
                    <option value="SHIPPING">ອໍເດີຢູ່ໃນລະຫວ່າງຈັດສົ່ງ</option>
                    <option value="COMPLETED">ອໍເດີສຳເລັດ</option>
                    <option value="CANCELLED">ປະຫວັດຍົກເລິກ</option>
                    <option value="IMAGE_NOT_YET_PAID">ແຈ້ງຍອດແຕ່ບໍ່ໂອນ</option>
                    <option value="PAYMENT_STILL_INCOMPLETE">ຍອດເງິນບໍ່ຖຶກຕ້ອງ</option>
                    <option value="WAITINGCONFIRM">ລໍຖ້າການຢືນຢັນ</option>
                    <option value="USERCONFIRM">ກວດສອບແລ້ວ</option>
                    <option value="PRINT_ORDER">ພີມບິນແລ້ວ</option>
                    <option value="SHIPPING_COMPLETED">ສົ່ງສຳເລັດ</option>
                  </Form.Select>
                </div>

                <div className="box-filter">
                  <label>ການຊໍາລະ</label>
                  <Form.Select
                    onChange={(e) => handleCchangePaid(e)}
                    className="form-control"
                    style={{
                      fontSize: "16px",
                      whiteSpace: "nowrap",
                    }}
                    value={isPaymented}
                    defaultValue={"ALL"}
                    aria-label="Default select example"
                  >
                    <option selected value="ALL">
                      --ທັງຫມົດ--
                    </option>
                    <option value="1">ຊໍາລະແລ້ວ</option>
                    <option value="0">ຍັງບໍ່ຊໍາລະ</option>
                  </Form.Select>
                </div>

                <div className="box-filter">
                  <label>ຂົນສົ່ງ</label>
                  <Form.Select
                    onChange={(e) => onSelectLogictics(e)}
                    disabled={!settingData?.settingByShopId?.isUseLogistics}
                    className="form-control"
                    style={{
                      fontSize: "16px",
                      whiteSpace: "nowrap",
                    }}
                    value={logicticsName}
                    defaultValue={""}
                    aria-label="Default select example"
                  >
                    <option selected value="">
                      --ທັງຫມົດ--
                    </option>
                    <option value="HAL">ຮຸ່ງອາລູນ</option>
                    <option value="MIXAY">ມີໄຊ</option>
                    {/* <option value="ANOUSITH">ອານຸສິດ</option> */}
                  </Form.Select>
                </div>

                {/* <div className="box-filter">
                  <div style={{ height: 31 }}></div>
                  
                </div> */}

              </div>

              <div style={{ marginTop: 3 }}>
                <Nav
                  variant="tabs"
                  defaultActiveKey="ALL"
                  className="justify-content-between"
                  style={{ background: '#f3f3f3', padding: 5, display: 'flex', borderRadius: 3 }}
                >
                  <div className="d-flex">
                    <Nav.Item>
                      <Nav.Link
                        eventKey="ALL"
                        onClick={() => setOrderGroupType("ALL")}
                        style={{
                          border: "solid 0px",
                          color: orderGroupType === "ALL" ? "blue" : "#000000",
                          fontStyle: "FontLao2",
                        }}
                      >
                        ທັງໝົດ
                      </Nav.Link>
                    </Nav.Item>
                    <Nav.Item>
                      <Nav.Link
                        eventKey={"LIVE"}
                        onClick={() => setOrderGroupType("LIVE")}
                        style={{
                          border: "solid 0px",
                          color: orderGroupType === "LIVE" ? "blue" : "#000000",
                        }}
                      >
                        ໄລຟ
                      </Nav.Link>
                    </Nav.Item>
                    <Nav.Item>
                      <Nav.Link
                        eventKey={"POST"}
                        onClick={() => setOrderGroupType("POST")}
                        style={{
                          border: "solid 0px",
                          color: orderGroupType === "POST" ? "blue" : "#000000",
                        }}
                      >
                        ໂພສ
                      </Nav.Link>
                    </Nav.Item>
                    <Nav.Item

                    >
                      <Nav.Link
                        eventKey={"KEY_IN"}
                        onClick={() => setOrderGroupType("KEY_IN")}
                        style={{
                          border: "solid 0px",
                          color:
                            orderGroupType === "KEY_IN" ? "blue" : "#000000",
                        }}
                      >
                        ສ້າງເອງ
                      </Nav.Link>
                    </Nav.Item>

                    <Nav.Item>
                      <Nav.Link
                        eventKey="POS"
                        onClick={() => setOrderGroupType("POS")}
                        style={{
                          border: "solid 0px",
                          color: orderGroupType === "POS" ? "blue" : "#000000",
                        }}
                      >
                        POS
                      </Nav.Link>
                    </Nav.Item>
                    <Nav.Item>
                      <Nav.Link
                        eventKey="SALE_PAGE"
                        onClick={() => {
                          setOrderGroupType("SALE_PAGE");
                          setlistpage(COMPLETED);
                        }}
                        style={{
                          border: "solid 0px",
                          color: orderGroupType === "SALE_PAGE" ? "blue" : "#000000",
                        }}
                      >
                        Sale Page
                      </Nav.Link>
                    </Nav.Item>

                  </div>
                  <div style={{ marginTop: width > 700 ? 0 : 3 }}>

                    <Button variant="danger" hidden={isShowFilterBox ? true : false} onClick={() => setIsShowFilterBox(true)} style={{ position: 'relative', paddingRight: "2em", width: 200, textAlign: 'left' }} >
                      <MdSearch style={{ fontSize: 20 }} /> ຄົ້ນຫາອໍເດີ້  <span className="short-cut-button">Ctrl+K</span>
                    </Button>

                  </div>

                  {isShowFilterBox && <Form className={`card-filter-order ${isShowFilterBox ? 'fade-up' : ''}`} ref={parentDivRef} onSubmit={onchangeFilterOrderDatas}>
                    <Form.Control
                      type="text"
                      placeholder="ຄົ້ນຫາ ເລກທີໃບສັ່ງຊື້ / ຊື່ລູກຄ້າ"
                      style={{ width: width > 700 ? 500 : "80%" }}
                      onChange={(e) => setValueFilterBox(e?.target?.value)}
                      value={valueFilterBox}
                      required
                      autoFocus
                    />
                    <Button type="submit" variant="light" style={{ background: LINEAR_GRADIENT_BG, color: COLOR_WHITE, width: 100 }}>
                      <MdSearch style={{ fontSize: 23 }} /> ຕົກລົງ
                    </Button>
                  </Form>}
                </Nav>
              </div>

              {/* {listpage === CREATED && ( */}
              {orderGroupLoading && !orderGroupData?.orderGroupsV2 ? (
                <LoadingSpinner />
              ) : (
                <CreateOrderTable
                  orderGroupLoading={orderGroupLoading}
                  isLoading={isLoading}
                  setOrderGroupType={setOrderGroupType}
                  orderGroupList={orderGroupList}
                  onSeletedAllOrder={onSeletedAllOrder}
                  setOrderGroupDownload={setOrderGroupDownload}
                  isSelectAll={isSelectAll}
                  setSelectedOrderGroup={setSelectedOrderGroup}
                  handleOrderStatusChange={handleOrderStatusChange}
                  selectedIds={selectedIds}
                  getSeletedOrder={getSeletedOrder}
                  gotoOrderGroupDetail={_gotoOrderGroupDetail}
                  setshowDetailModal={setshowDetailModal}
                  _limit={_limit}
                  _skip={_skip}
                  listpage={listpage}
                  setSelectedImage={setSelectedImage}
                  setshowImageModal={setshowImageModal}
                  getCfMessage={getCfMessage}
                  orderGroupData={orderGroupData}
                  setPaySlips={setPaySlips}
                  setSelectedOrderGroupStatus={setSelectedOrderGroupStatus}
                  handleCreatePreOrder={handleCreatePreOrder}
                  isUseLogistics={settingData?.settingByShopId?.isUseLogistics}
                />
              )}
              {/* )} */}

              {orderGroupList.length > 0 &&
                <div className="d-flex justify-content-between">
                  <div className="d-flex gap-4 w-100">
                    <Dropdown>
                      <Dropdown.Toggle 
                        variant="outline-secondary" 
                        id="export-dropdown"
                        style={{
                          borderRadius: "3px",
                          width: 'auto',
                          padding: '0 10px',
                          height: 38,
                          display: 'flex',
                          alignItems: 'center',
                          gap: '8px'
                        }}
                      >
                        <FaDownload />
                        ດາວໂຫຼດເອັກເຊວ
                      </Dropdown.Toggle>

                      <Dropdown.Menu>
                        <Dropdown.Item 
                          onClick={() => {
                            if (orderGroupDownload.length <= 0) {
                              addToast("ກະລຸນາເລືອກອໍເດີ້ໃດຫນຶ່ງກ່ອນ!", {
                                appearance: "warning",
                                autoDismiss: true,
                              });
                              return;
                            }
                            // Trigger the ReactHTMLTableToExcel export
                            const exportButton = document.getElementById("test-table-xls-button");
                            if (exportButton) {
                              exportButton.click();
                            }
                          }}
                          disabled={orderGroupDownload.length <= 0}
                        >
                          <FaDownload className="me-2" />
                          ດາວໂຫຼດເອັກເຊວ(ແບບມາດຕະຖານ)
                        </Dropdown.Item>
                        
                        <Dropdown.Item 
                          onClick={() => {
                            if (orderGroupDownload.length <= 0) {
                              addToast("ກະລຸນາເລືອກອໍເດີ້ໃດຫນຶ່ງກ່ອນ!", {
                                appearance: "warning",
                                autoDismiss: true,
                              });
                              return;
                            }
                            handleExportToExcelNewFormat();
                          }}
                          disabled={orderGroupDownload.length <= 0}
                        >
                          <FaDownload className="me-2" />
                          Excel custom format
                        </Dropdown.Item>
                      </Dropdown.Menu>
                    </Dropdown>

                    {/* Hidden ReactHTMLTableToExcel component */}
                    <div style={{ display: 'none' }}>
                      <ReactHTMLTableToExcel
                        id="test-table-xls-button"
                        className="btn btn-app hoverme"
                        table="table-to-xls"
                        filename={"order_datas_" + new Date().toISOString()}
                        sheet="Orders"
                        buttonText="ດາວໂຫຼດເອັກເຊວ"
                      />
                    </div>

                  </div>


                  <div style={{ width: "100%", display: 'flex', gap: 3, justifyContent: 'end' }}>
                    <Form.Group style={{ minWidth: 90 }} controlId="exampleForm.ControlInput1">
                      <Form.Select value={selectLimit} onChange={handleSelectLimit} aria-label="select-limit">
                        <option value="50" >50</option>
                        <option value="100">100</option>
                        <option value="150">150</option>
                        <option value="200">200</option>
                        {/* <option value="300">300</option>
                        <option value="500">500</option>
                        <option value="1000">1000</option> */}
                      </Form.Select>
                    </Form.Group>
                    {orderGroupTotal > 0 &&
                      Pagination_helper(orderGroupTotal, "/orders", ``)}
                  </div>
                </div>
              }
            </div>
          </div>


        </div>
      </div>

      <div id="sticky-btn-order">
        <Button
          variant={orderGroupDownload && orderGroupDownload.length > 0 ? "secondary" : "outline-secondary"}
          onClick={() => {
            if (orderGroupDownload.length <= 0) {
              addToast("ກະລຸນາເລືອກອໍເດີ້ໃດຫນຶ່ງກ່ອນ!", {
                appearance: "warning",
                autoDismiss: true,
              });
              return;
            }
            // setShowOrderAll(true)
            handleUpdateOrderAll();
          }}
          disabled={
            orderGroupDownload && orderGroupDownload.length > 0
              ? false
              : true
          }

        >
          <MdEditNote style={{ fontSize: 24 }} />
          ແກ້ໄຂອໍເດີ້
        </Button>

        {orderGroupDownload.length > 0 ? (
          <div className="card-dropdown-action" >
            <Button variant={showDropdownAction ? "danger" : "success"} onClick={(e) => setShowDropdownAction(!showDropdownAction)} > {showDropdownAction ? <> ປີດອອກ  <MdClose /> </> : <>ຕົວເລືອກອື່ນໆ <HiDotsVertical />  </>} </Button>

            {showDropdownAction &&
              <div ref={dropdownRef} className="card-child-dropdown" onClick={(e) => e.stopPropagation()}>
                {/* <div onClick={() => setShowDropdownAction(false)} className="close-child-dropdown"><MdClose /> </div> */}
                <BtnJointAllOrderGroup setIsFetch={setIsFetch} orderGroupSelect={orderGroupDownload} setIsSelectAll={setIsSelectAll} setOrderGroupDownload={setOrderGroupDownload} setSelectedIds={setSelectedIds} />
                <BtnJointCfOrderGroup setIsFetch={setIsFetch} orderGroupSelect={orderGroupDownload} setIsSelectAll={setIsSelectAll} setOrderGroupDownload={setOrderGroupDownload} setSelectedIds={setSelectedIds} />
                <BtnCancelJointOrderGroup setIsFetch={setIsFetch} selectedIds={selectedIds} setIsSelectAll={setIsSelectAll} setOrderGroupDownload={setOrderGroupDownload} setSelectedIds={setSelectedIds} />
                <ReactToPrint
                  trigger={() => (
                    <Button className="w-100 text-left" disabled={orderGroupDownload && orderGroupDownload.length > 0 ? false : true} variant="light"><MdPrint /> ພີມບິນອໍເດີ້</Button>
                  )}
                  content={() => componentRef.current}
                  onAfterPrint={onAfterPrintBill}
                />
                <RefreshClaimBalanceFailed setSelectedIds={setSelectedIds} idIn={selectedIds} />
                <DropdownClaimBalance setSelectedIds={setSelectedIds} isSelectAll={isSelectAll} idIn={selectedIds} />
                <ConfirmBalance setSelectedIds={setSelectedIds} idIn={selectedIds} />

                <Button disabled={orderGroupDownload && orderGroupDownload.length > 0 ? false : true} hidden={!settingData?.settingByShopId?.isUseLogistics} onClick={handleLoopOrderDelivery} variant="light" className="w-100 text-left">
                  <FaLuggageCart /> ຈັດສົ່ງຫຼາຍອໍເດີ້
                </Button>
              </div>}

          </div>
        ) : null}
      </div>

      {/* <div style={{ width: 800, border:'1px solid red', padding:10 }}>
        <BillOrder100x150_V2
          ref={componentRef}
          data={orderGroupDownload}
          shopData={shopDataDetail}
          rateData={rateData}
        />
      </div> */}

      <div style={{ display: "none", width: "377px", heigth: "566px" }}>
        {shopDataDetail?.exampleBill === "IS_LOGICTICS" ? (
          <BillOrder100x150
            ref={componentRef}
            data={orderGroupDownload}
            shopData={shopDataDetail}
            rateData={rateData}
          />
        ) : shopDataDetail?.exampleBill === "BILL_LOGICTICS_V2" ? (
          <BillOrder100x150_V2
            ref={componentRef}
            data={orderGroupDownload}
            shopData={shopDataDetail}
            rateData={rateData}
          />
        ) : shopDataDetail?.exampleBill === "ISPRICE_BOLD" ? (
          <OrderBillWithNameOnePageV2
            ref={componentRef}
            data={orderGroupDownload}
            shopData={shopDataDetail}
            rateData={rateData}
          />
        ) : (
          <OrderBillWithNameOnePage
            ref={componentRef}
            data={orderGroupDownload}
            shopData={shopDataDetail}
          />
        )}
      </div>

      {/* select delivery the create pre-order */}
      <SelectDeliveryDailog logicticsName={logicticsName} openSelect={openSelectLogictics} onCloseSelectModal={onCancelSelectItem} orderGroupdataProps={orderGroupIdSelect} _filter={_filter} />

      <Modal
        size="ms"
        show={showImageModal}
        onHide={() => setshowImageModal(false)}
      >
        <Modal.Header closeButton>
          <Modal.Title>{paySlips?.length >= 2 ? "ບິນຊຳລະທັງໝົດ" : "ບິນຊຳລະ"}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {selectedImage && <img
            alt="payment"
            src={imageRender(selectedImage)}
            // src={imageRender(paySlips[0])}
            height="100%"
            width="100%"
            style={{
              objectFit: "contain",
              width: "100%",
              height: "100%",
              maxHeight: "400px",
            }}
          />}
          <br />
          {paySlips?.length >= 1 && <div style={{ display: 'flex', gap: 5, marginTop: 5, flexDirection: 'column', }}>
            {paySlips.map((item, _index) => (
              <div style={{ marginTop: 10, borderTop: '1px dashed #777', width: '100%' }}>
                <p className="w-full text-center">ບິນຊຳລະ</p>
                <img key={_index}
                  src={imageRender(item)}
                  style={{ width: '100%', height: 'auto', minHeight: 370 }} />
              </div>
            ))}
          </div>}

        </Modal.Body>
      </Modal>

      <Modal show={showDetailModal} onHide={() => setshowDetailModal(false)} size="lg">
        <Modal.Header closeButton style={{ textAlign: "center" }}>
          <Modal.Title>
            ເລກບິນ: {selectedOrderGroup?.code}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <OrderDetails selectedOrderGroup={selectedOrderGroup} />
        </Modal.Body>
      </Modal>

      <Modal
        size="md"
        centered
        show={showOrder}
        onHide={() => {
          if (updateOrderGroupLoading) return;
          triggerHideShowOrder();
        }}
        keyboard={false}
      >
        <Modal.Header>
          <div style={{ fontSize: "22px" }}>ເລືອກສະຖານະອໍເດີ້ ເພື່ອອັບເດດ</div>
        </Modal.Header>
        <Modal.Body>
          <div style={{ display: 'flex', flexWrap: 'wrap', gap: 10, width: '100%' }}>

            {statusDataStrings.map((status) => (
              <Button
                key={status}
                variant={selectedOrderGroupStatus === status ? "info" : "outline-info"}
                onClick={() => {
                  setSelectedOrderGroupStatus(status);
                  // handleButtonClick(status);
                }}
                style={{ padding: '.85em 2em', }}
              >
                <FiAward /> &nbsp;{convertOrderStatus(status)}
              </Button>
            ))}
          </div>
        </Modal.Body>
        <Modal.Footer style={{ display: "flex", justifyContent: "center" }}>
          <div
            style={{
              display: "flex",
            }}
          >
            <Button
              onClick={triggerHideShowOrder}
              disabled={updateOrderGroupLoading}
              variant="secondary"
              style={{
                marginRight: "8px",
                color: " #252A31",
                background: "#E8EDF1",
                border: "none",
              }}
            >
              ຍົກເລີກ
            </Button>
            <Button
              onClick={() => {
                _onUpdateOrderGroupStatus();
                // triggerHideShowOrder();
                // notifyCreateOrderSuccess();
              }}
              style={{
                width: 125,
                background: COLOR_APP,
                border: 'none'
              }}
            >
              {updateOrderGroupLoading ? (
                <>
                  <Spinner animation="border" size="sm" /> loading...
                </>
              ) : (
                "ບັນທຶກ"
              )}
            </Button>
          </div>
        </Modal.Footer>
      </Modal>

      <Modal
        size="md"
        centered
        show={showOrderAll}
        onHide={() => {
          if (updateorderManyLoading) return;
          handleHideUpdateOrderAll();
        }}
        keyboard={false}
      >
        <Modal.Header>
          <div style={{ fontSize: "22px" }}>ອັບເດດ ສະຖານະອໍເດີ້</div>
        </Modal.Header>
        <Modal.Body>
          <div style={{ display: 'flex', flexWrap: 'wrap', gap: 10, width: '100%' }}>

            {statusDataStrings.map((status) => (
              <Button
                key={status}
                variant={selectedOrderGroupStatus === status ? "info" : "outline-info"}
                onClick={() => {
                  setSelectedOrderGroupStatus(status);
                  // handleButtonClick(status);
                }}
                style={{ padding: '.85em 2em', }}
              >
                <FiAward /> &nbsp;{convertOrderStatus(status)}
              </Button>
            ))}
          </div>
        </Modal.Body>
        <Modal.Footer style={{ display: "flex", justifyContent: "center" }}>
          <div
            style={{
              display: "flex",
            }}
          >
            <Button
              onClick={handleHideUpdateOrderAll}
              disabled={updateorderManyLoading}
              variant="secondary"
              style={{
                marginRight: "8px",
                width: 72,
                color: " #252A31",
                background: "#E8EDF1",
                border: "0px",
              }}
            >
              ຍົກເລີກ
            </Button>
            <Button
              onClick={() => {
                _onUpdateOrderGroupStatusAll();
                // triggerHideShowOrder();
                // notifyCreateOrderSuccess();
              }}
              variant="primary"
              style={{
                width: 125,
                background: COLOR_APP,
              }}
            >
              {updateorderManyLoading ? (
                <>
                  <Spinner animation="border" size="sm" /> loading...
                </>
              ) : (
                "ບັນທຶກ"
              )}
            </Button>
          </div>
        </Modal.Footer>
      </Modal>

      {/* modal current date  */}
      <CurrentDateModal
        onCloseModal={() => setIsCurrentModals(false)}
        openModal={isCurrentModals}
        setCdFillter={setCdFillter}
        setActiveButton={setActiveButton}
        activeButton={activeButton}
        backdrop={true}

      />

      <ModalConfirmComponent
        showConfirmModal={showCreatePreorder}
        handleCancel={() => setShowCreatePreorder(false)}
        handleConfirm={() => handleCreateManyPreOrderDelivery()}
        loadingConfirm={createManyPreorderLoading}
        title="ແຈ້ງເຕືອນ"
        text={`
          ທ່ານຕ້ອງການ ສ້າງອໍເດີ້ເພື່ອຈັດສົ່ງແທ້ບໍ່!
          ລາຍການຂົນສົ່ງ: ${isDeliveriesLA.length > 0 ? isDeliveriesLA.join(', ') : "ບໍ່ມີລາຍການຂົນສົ່ງ"}
          ຈຳນວນລາຍການຈັດສົ່ງ: ${orderDeliveryIds.length} ອໍເດີ້
        `.trim()}
      />

    </div >
  );
}

export default Orders;
